<template>
    <div
        class="home"
        :class="{ qiyangHome: qyBgSize }"
        :style="{ height: minHeight, backgroundSize: qyBgSize }"
    >
        <div v-if="$route.query.isHeader !== 'no'" class="header">
            <div class="title">{{ title }}</div>
        </div>
        <div class="body" :class="{ qiyangBody: qyBgSize }">
            <div class="back-home" @click="backHome">
                <div class="back-home-bg"></div>
                <div class="back-home-text all-center">
                    <img src="../../assets/images/detail/home.png" alt="" />
                    <p>返回首页</p>
                </div>
            </div>
            <div class="left">
                <div class="item-title">标的物详情</div>
                <div class="item-info">
                    <img src="../../assets/images/detail/icon_1.png" alt="" />
                    <p>标的名称：{{ target.targetName }}</p>
                </div>
                <div class="item-info">
                    <img src="../../assets/images/detail/icon_2.png" alt="" />
                    <p>所在地区：{{ target.areaName }}</p>
                </div>
                <div class="item-info">
                    <img src="../../assets/images/detail/icon_3.png" alt="" />
                    <p>
                        转出面积/数量：{{ target.number
                        }}{{ target.transferUnit }}
                    </p>
                </div>
                <div class="item-info">
                    <img src="../../assets/images/detail/icon_4.png" alt="" />
                    <p>标的类型：{{ target.businessName }}</p>
                </div>
                <div class="item-info">
                    <img src="../../assets/images/detail/icon_5.png" alt="" />
                    <p style="-webkit-line-clamp: 4;line-clamp: 4;">
                        四至： 东至：{{ target.east }} 南至：{{
                            target.south
                        }}
                        西至：{{ target.west }} 北至：{{ target.north }}
                    </p>
                </div>
                <div class="item-info" style="min-height: 120px">
                    <img src="../../assets/images/detail/icon_6.png" alt="" />
                    <p style="-webkit-line-clamp: 8;line-clamp: 8;">
                        其他说明：{{ target.otherDescription }}
                    </p>
                </div>
                <div class="item-info" style="min-height: 240px">
                    <img src="../../assets/images/detail/icon_7.png" alt="" />
                    <p style="-webkit-line-clamp: 8;line-clamp: 8;">
                        附着物：{{ target.detailedInfo }}
                    </p>
                </div>
            </div>
            <div class="center" :class="{ 'one-center': !fileList.length }">
                <div class="center-up">
                    <div class="center-up-title">
                        <img
                            class="left-icon"
                            src="../../assets/images/detail/left.png"
                            alt=""
                        />
                        <p>{{ form.areaName }}{{ form.title }}</p>
                        <img
                            class="right-icon"
                            src="../../assets/images/detail/right.png"
                            alt=""
                        />
                    </div>
                    <div class="center-up-info">
                        <!--                        <p>基础信息</p>-->
                        <ul>
                            <li class="up-center">
                                <p class="base-label">所在地区：</p>
                                <p class="base-text">{{ target.areaName }}</p>
                            </li>
                            <li class="up-center">
                                <p class="base-label">转出期限：</p>
                                <p class="base-text">
                                    {{
                                        transferProject.projectPeriodUnit === 4
                                            ? ''
                                            : transferProject.transferYears
                                    }}<span
                                        v-if="
                                            transferProject.projectPeriodUnit ===
                                                1
                                        "
                                        >天</span
                                    ><span
                                        v-if="
                                            transferProject.projectPeriodUnit ===
                                                2
                                        "
                                        >月</span
                                    ><span
                                        v-if="
                                            transferProject.projectPeriodUnit ===
                                                3
                                        "
                                        >年</span
                                    ><span
                                        v-if="
                                            transferProject.projectPeriodUnit ===
                                                4
                                        "
                                        >永久</span
                                    >
                                </p>
                            </li>
                            <li class="up-center">
                                <p class="base-label">转出方式：</p>
                                <p class="base-text">
                                    {{ transferProject.transferModeName }}
                                </p>
                            </li>
                            <li class="up-center">
                                <p class="base-label">转出面积/数量：</p>
                                <p class="base-text">
                                    {{ transferProject.transferNumber
                                    }}{{ transferProject.transferUnit }}
                                </p>
                            </li>
                            <li class="up-center">
                                <p class="base-label">报名开始时间：</p>
                                <p class="base-text">
                                    {{ form.signStartTime }}
                                </p>
                            </li>
                            <li class="up-center">
                                <p class="base-label">报名结束时间：</p>
                                <p class="base-text">{{ form.signEndTime }}</p>
                            </li>
                            <li class="up-center">
                                <p class="base-label">竞拍开始时间：</p>
                                <p class="base-text">
                                    {{ form.auctionStartTime }}
                                </p>
                            </li>
                            <li class="up-center">
                                <p class="base-label">竞拍结束时间：</p>
                                <p class="base-text">
                                    {{ form.auctionEndTime }}
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="center-down" v-if="fileList.length">
                    <el-carousel
                        height="456px"
                        indicator-position="none"
                        arrow="never"
                    >
                        <el-carousel-item
                            v-for="(it, index) in fileList"
                            :key="index"
                        >
                            <ul>
                                <li
                                    v-for="item in it"
                                    :key="`${item.id}-${item.remark}`"
                                    @click="seeImg(item)"
                                >
                                    <div
                                        v-if="item.remark === '4'"
                                        class="center-down-img"
                                    >
                                        <img :src="item.url" alt="" />
                                        <span class="center-down-img-vr"
                                            >VR</span
                                        >
                                    </div>
                                    <template v-else>
                                        <div
                                            class="center-down-img center-down-video"
                                            v-if="item.fileType === 'mp4'"
                                        >
                                            <video :src="item.url"></video>
                                            <img
                                                src="../../assets/images/detail/video_play.png"
                                                alt=""
                                            />
                                        </div>
                                        <div class="center-down-img" v-else>
                                            <img :src="item.url" alt="" />
                                        </div>
                                    </template>
                                </li>
                            </ul>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <div class="right">
                <div
                    class="right-up"
                    v-if="
                        form.businessStatus === 1 ||
                            form.businessStatus === 2 ||
                            form.businessStatus === 11
                    "
                >
                    <div class="item-title _item-title">等待竞拍</div>
                    <p class="right-up-price all-center">
                        起拍价：<span class="price-number">{{
                            transferProject.priceNumber
                        }}</span
                        ><span class="price-unit">{{
                            transferProject.priceUnit
                        }}</span>
                    </p>
                    <p class="right-up-time all-center">
                        距离开始：<span>{{ time1 }}</span>
                    </p>
                </div>
                <div class="right-up" v-else-if="form.businessStatus === 3">
                    <div class="item-title _item-title">正在竞拍</div>
                    <p class="right-up-price all-center _right-up-price_">
                        <span class="price-label">当前价：</span>
                        <span class="price-number">{{
                            form.turnoverPrice || transferProject.priceNumber
                        }}</span>
                        <span class="price-unit">{{
                            transferProject.priceUnit
                        }}</span>
                    </p>
                    <p class="right-up-price all-center _right-up-price">
                        <span class="price-label">起拍价：</span>
                        <span class="price-number">{{
                            transferProject.priceNumber
                        }}</span>
                        <span class="price-unit">{{
                            transferProject.priceUnit
                        }}</span>
                    </p>
                    <p class="right-up-time all-center">
                        距离结束：<span>{{ time1 }}</span>
                    </p>
                </div>
                <div class="right-up" v-else-if="form.businessStatus === 4">
                    <div class="item-title _item-title">竞拍成功</div>
                    <p class="right-up-price all-center _right-up-price_">
                        <span class="price-label">当前价：</span>
                        <span class="price-number">{{
                            form.turnoverPrice || transferProject.priceNumber
                        }}</span>
                        <span class="price-unit">{{
                            transferProject.priceUnit
                        }}</span>
                    </p>
                    <p class="right-up-price all-center _right-up-price">
                        <span class="price-label">起拍价：</span>
                        <span class="price-number">{{
                            transferProject.priceNumber
                        }}</span>
                        <span class="price-unit">{{
                            transferProject.priceUnit
                        }}</span>
                    </p>
                    <p class="right-up-time all-center">
                        距离结束：<span>00 : 00 : 00</span>
                    </p>
                </div>
                <div class="right-up" v-else-if="form.businessStatus === 5">
                    <div class="item-title _item-title">竞拍结束</div>
                    <p class="right-up-price all-center">
                        起拍价：<span class="price-number">{{
                            transferProject.priceNumber
                        }}</span
                        ><span class="price-unit">{{
                            transferProject.priceUnit
                        }}</span>
                    </p>
                    <p class="right-up-time all-center">
                        距离结束：<span>00 : 00 : 00</span>
                    </p>
                </div>
                <div class="right-up" v-else>
                    <div class="item-title _item-title">竞拍结束</div>
                    <p class="right-up-price all-center">
                        起拍价：<span class="price-number">{{
                            transferProject.priceNumber
                        }}</span
                        ><span class="price-unit">{{
                            transferProject.priceUnit
                        }}</span>
                    </p>
                    <p class="right-up-time all-center">
                        距离结束：<span>00 : 00 : 00</span>
                    </p>
                </div>
                <div class="right-down">
                    <div class="item-title">出价记录</div>
                    <div class="right-down-list">
                        <p>
                            实时出价情况<span
                                >共出价 {{ tableData.length }} 次</span
                            >
                        </p>
                        <table-info
                            :key="tableKey"
                            :limitMoveNum="10"
                            v-if="tableData.length > 0"
                            :columns="columns"
                            tableType="出价记录"
                            :table-data="tableData"
                        />
                        <p v-else class="no-data">暂无数据</p>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" center>
            <iframe
                v-if="fileType === 'link'"
                width="100%"
                height="700"
                :src="dialogUrl"
                frameborder="0"
            ></iframe>
            <video
                v-else-if="fileType === 'mp4'"
                style="width: 100%;height: 700px;margin: 0 auto"
                :src="dialogUrl"
                autoplay
                controls
            ></video>
            <img
                v-else
                style="width: 100%;height: 700px;margin: 0 auto"
                :src="dialogUrl"
                alt
            />
        </el-dialog>
    </div>
</template>

<script>
import TableInfo from '@/components/TableInfo'
import Socket, { uri2 } from '@/socket/index'
import * as screenAPI from '@/api/screen'
import { formatDate } from '@/utils/index'
import eventHub from '@/utils/eventHub'
import env from '@/config/env'

export default {
    components: {
        TableInfo
    },
    data() {
        return {
            title: '',
            minHeight: '',
            qyBgSize: '',
            // time: ['', '', ''],
            locId: sessionStorage.getItem('locId'),
            columns: [
                { title: '状态', field: 'status', width: '10%' },
                {
                    title: '竞拍人',
                    field: 'biddingPhone',
                    tag: 'hasPriorityBidding',
                    width: '20%',
                    type: 'priority'
                },

                { title: '价格', field: 'price', type: 'emphasize' },
                { title: '时间', field: 'biddingTimeStr', width: '30%' }
            ],
            tableData: [],
            form: {},
            target: {},
            transferProject: {},
            time1: '',
            fileList: [],
            dialogVisible: false,
            dialogUrl: '',
            dialogTitle: '查看图片',
            fileType: '',
            tableKey: 0,
            timeSet: null,
            countTimeNum: 0,
            date3: 0,
            hasSetTime: false
        }
    },
    watch: {
        time1: {
            handler: function(val) {
                if (val === '0天 00:00:00' || val === '0天 -1:-1:-1') {
                    setTimeout(() => {
                        this.auctionInfo()
                        this.biddingRecord()
                    }, 200)
                    clearTimeout(this.timeSet)
                    this.timeSet = null
                }
            }
        }
    },
    methods: {
        backHome() {
            this.$router.push({
                name: this.$route.query.custom,
                params: {
                    id: !+this.locId ? 'zhongguo' : this.locId
                },
                query: {
                    isHeader: this.$route.query.isHeader
                }
            })

            location.reload()
        },
        seeImg(item) {
            this.dialogVisible = true
            if (item.remark === '4') {
                this.dialogUrl = this.form.bdList[0].vrHref
                this.fileType = 'link'
                this.dialogTitle = '查看VR'
            } else {
                this.dialogUrl = item.url
                this.fileType = item.fileType
                this.dialogTitle =
                    this.fileType === 'mp4' ? '查看视频' : '查看图片'
            }
        },
        async getNewCountdown() {
            const params = {
                id: this.$route.query.id
            }
            const response = await screenAPI.auctionStartEndDate(params)
            if (+response.code === 200 && response.data !== undefined) {
                this.form.currentTime = formatDate(response.data.currentTime)
                let date = 0
                if (response.data.businessStatus === 3) {
                    date = response.data.leftTime
                    this.form.auctionEndTime = formatDate(
                        response.data.leftTime
                    )
                } else {
                    date = response.data.auctionStartTime
                    this.form.auctionStartTime = formatDate(
                        response.data.auctionStartTime
                    )
                }

                if (!this.hasSetTime) {
                    this.date3 = date - response.data.currentTime // 时间差的毫秒数
                    this.hasSetTime = true
                }
            } else {
                console.log('倒计时校准接口非 200 ---', response.code)
            }
        },
        timeDiff() {
            const _this = this

            function timer() {
                // 10 秒校准一次倒计时
                if (_this.countTimeNum >= 10) {
                    _this.getNewCountdown()
                    _this.countTimeNum = 0
                    _this.hasSetTime = false
                }
                _this.countTimeNum += 1

                let days =
                    Math.floor(_this.date3 / (24 * 3600 * 1000)) < 0
                        ? 0
                        : Math.floor(_this.date3 / (24 * 3600 * 1000)) //计算出相差天数

                //计算出小时数
                let leave1 = _this.date3 % (24 * 3600 * 1000)
                let hours =
                    Math.floor(leave1 / (3600 * 1000)) < 0
                        ? 0
                        : Math.floor(leave1 / (3600 * 1000))
                //计算相差分钟数
                let leave2 = leave1 % (3600 * 1000)
                let minutes =
                    Math.floor(leave2 / (60 * 1000)) < 0
                        ? 0
                        : Math.floor(leave2 / (60 * 1000))
                //计算相差秒数
                let leave3 = leave2 % (60 * 1000)
                let seconds =
                    Math.round(leave3 / 1000) < 0
                        ? 0
                        : Math.round(leave3 / 1000)
                _this.time1 =
                    (days < 0 ? '0' : days) +
                    '天 ' +
                    (0 <= hours && hours < 10 ? '0' + hours : hours) +
                    ':' +
                    (0 <= minutes && minutes < 10 ? '0' + minutes : minutes) +
                    ':' +
                    (0 <= seconds && seconds < 10 ? '0' + seconds : seconds)
                _this.date3 -= 1000

                _this.timeSet = setTimeout(timer, 1000)
            }
            timer()
        },
        async biddingRecord() {
            const params = {
                auctionId: this.$route.query.id,
                siteId: sessionStorage.getItem('locId'),
                userId: ''
            }
            const response = await screenAPI.biddingRecord(params)
            this.tableData = response.data
            for (let i = 0; i < this.tableData.length; i++) {
                this.tableData[i].status =
                    +this.tableData[i].isFirst === 1 ? '领先' : '出局'
                this.tableData[i].price =
                    this.tableData[i].biddingPrice +
                    this.tableData[i].priceUnitName
            }
        },
        async auctionInfo() {
            const params = {
                id: this.$route.query.id,
                siteId: sessionStorage.getItem('locId'),
                userId: ''
            }
            this.fileList = []
            const response = await screenAPI.auctionInfo(params)
            this.form = response.data
            let fileList = [
                ...this.form.bdList[0].videoList,
                ...this.form.bdList[0].attachmentList
            ]
            if (this.form.bdList[0].vrHref) {
                if (this.form.bdList[0].vrList.length) {
                    fileList.unshift(this.form.bdList[0].vrList[0])
                } else {
                    let copyAttachment = JSON.stringify(
                        this.form.bdList[0].attachmentList[0]
                    )
                    let copyImg = JSON.parse(copyAttachment)
                    copyImg.remark = '4'
                    fileList.unshift(copyImg)
                }
            }
            if (fileList.length < 5 && fileList.length > 0) {
                this.fileList.push(fileList)
            } else if (fileList.length > 4) {
                this.fileList = []
                for (let index = 0; index < fileList.length; index++) {
                    if (index !== 0 && index % 4 === 0) {
                        this.fileList.push(fileList.slice(index - 4, index))
                    }
                }
                this.fileList.push(
                    fileList.slice((fileList.length % 4) * -1, fileList.length)
                )
            } else {
                this.fileList = []
            }

            this.target = response.data.bdList[0] || {}
            this.transferProject = response.data.transferProject || {}
            this.timeDiff()
        }
        // setTime() {
        //     const filling = (n) => (n >= 10 ? n : `0${n}`)
        //     const t = new Date()
        //     this.time = [
        //         `${t.getFullYear()}-${filling(t.getMonth() + 1)}-${filling(
        //             t.getDate()
        //         )}`,
        //         `${filling(t.getHours())}:${filling(t.getMinutes())}`,
        //         [
        //             '星期天',
        //             '星期一',
        //             '星期二',
        //             '星期三',
        //             '星期四',
        //             '星期五',
        //             '星期六'
        //         ][t.getDay()]
        //     ]
        // }
    },
    beforeMount() {
        const clientWidth = document.documentElement.clientWidth

        if (env.QYLOCID !== this.$route.path.split('/')[1]) {
            this.minHeight = `${(1080 / 1920) * clientWidth}px`
            this.qyBgSize = ``
        } else {
            // 祁阳大屏样式特殊处理
            this.minHeight = `100vh`
            this.qyBgSize = `${clientWidth}px 100vh`
        }
    },
    mounted() {
        document.addEventListener('visibilitychange', function() {
            if (!document.hidden) {
                setTimeout(() => {
                    location.reload()
                }, 1000)
            }
        })
        this.title = sessionStorage.getItem('documentTitle')
        this.getNewCountdown()
        this.auctionInfo()
        this.biddingRecord()
        // 初始化 socket
        Socket.inits(uri2 + '-' + this.$route.query.id)
        eventHub.$on('setAmList', (data) => {
            console.log('接收实时数据---', data)
            this.$set(this.form, 'turnoverPrice', data.turnoverPrice)
            for (const key in data) {
                if (key === 'auctionBiddingRecord') {
                    let arr = this.tableData
                    let obj = data[key]
                    obj.price = obj.biddingPrice + obj.priceUnitName
                    for (let i = 0; i < this.tableData.length; i++) {
                        this.tableData[i].status = '出局'
                    }
                    obj.status = +obj.isFirst === 1 ? '领先' : '出局'
                    arr.unshift(obj)
                    this.$nextTick(() => {
                        this.$set(this, 'tableData', [...arr])
                    })
                    this.tableKey += 1
                }
            }
            this.$once('hook:beforeDestroy', () => {
                clearTimeout(this.timeSet)
            })
        })
        /**
         * 每 1 秒更新一次时间
         */
        // this.setTime()
        // setInterval(() => {
        //     this.setTime()
        // }, 1000 * 1)
    },
    destroyed() {
        Socket.destroy()
    }
}
</script>
<style scoped>
/deep/.el-dialog__header {
    padding: 20px 10px 0;
}
/deep/.el-dialog__title {
    color: #fff;
    font-size: 22px;
}
/deep/ .el-dialog__headerbtn {
    font-size: 24px;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
    color: #fff !important;
}
/deep/.el-dialog {
    background: rgba(7, 16, 58, 0.8);
    box-shadow: 0 0 5px 1px #1b68bd;
}
/deep/.el-dialog--center .el-dialog__body {
    text-align: center;
}
</style>
<style lang="scss" scoped>
.table-info,
.solid-box,
.echarts-block {
    width: 620px !important;
}
.qiyangHome {
    justify-content: center;
    .qiyangBody {
        flex-grow: 0 !important;
    }
}
.home {
    font-family: PingFangSC-Regular, Microsoft YaHei, SimSun;
    display: flex;
    flex-direction: column;
    background-size: 1920px 1080px;
    background-repeat: no-repeat;
    background-position: center top;
    background-image: url('../../assets/images/detail/bg2.png');
    background-color: #04090f; // for ie10
    > .header {
        width: 100%;
        height: 76px;
        background-size: 1920px 100%;
        background-repeat: no-repeat;
        background-position: center top;
        background-image: url('../../assets/images/home_header_bg.png');
        position: relative;
        flex-shrink: 0;

        > .title {
            font-family: SourceHanSansCN-Bold;
            line-height: 76px;
            text-align: center;
            font-size: 42px;
            color: #ffffff;
            letter-spacing: 1.15px;
            text-align: center;
            position: relative;
            top: -5px;
        }

        // > .time {
        //     font-size: 18px;
        //     color: #67f0ff;
        //     height: 25px;
        //     top: 7.5px;
        //     line-height: 25px;
        //     position: absolute;
        //     right: 22px;
        //     display: flex;
        //     align-items: center;

        //     > .hour {
        //         margin-left: 16px;
        //     }

        //     > .week {
        //         margin-left: 32.5px;
        //     }
        // }
    }

    > .body {
        position: relative;
        padding: 45px 15px 11px 15px;
        display: flex;
        justify-content: space-between;
        flex-grow: 1;
        box-sizing: border-box;
        .back-home {
            position: absolute;
            padding: 2px 10px;
            width: 120px;
            height: 30px;
            left: 36px;
            top: 0;
            cursor: pointer;
            .back-home-bg {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 0;
                background-image: linear-gradient(
                    226deg,
                    #3790f1 0%,
                    #1b68bd 100%
                );
                box-shadow: 0 0 5px 1px #1b68bd;
                transform: rotateZ(10deg) skew(-10deg, -10deg);
            }
            .back-home-text {
                position: absolute;
                top: -1px;
                left: -4px;
                width: 100%;
                height: 100%;
                z-index: 0;
                img {
                    width: 22px;
                    margin-right: 3px;
                    margin-top: 3px;
                }
                p {
                    font-size: 18.31px;
                    color: #ffffff;
                    line-height: 20px;
                    margin: 0;
                    text-align: center;
                    text-shadow: 0 1px 5px rgba(70, 102, 255, 0.5);
                }
            }
        }
        .left {
            width: 612px;
            background-image: url('../../assets/images/detail/border_1.png');
            .item-info {
                position: relative;
                padding: 0 24px 0 64px;
                width: calc(100% - 88px);
                min-height: 30px;
                margin: 20px 0 20px;
                ._item-info {
                    display: flex;
                }
                img {
                    width: 26px;
                    height: 26px;
                    position: absolute;
                    left: 22px;
                    top: 5px;
                }
                p {
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    line-clamp: 1;
                    -webkit-box-orient: vertical;
                    font-size: 20px;
                    color: #67f0ff;
                    line-height: 30px;
                    margin: 0;
                }
            }
        }
        .center {
            width: 650px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            &.one-center {
                flex-direction: unset;
                -webkit-align-items: center;
                align-items: center;
            }
            .center-up {
                background-size: 100% 106%;
                background-position: center center;
                background-repeat: no-repeat;
                background-image: url('../../assets/images/detail/border_4.png');
                width: 100%;
                height: 460px;
                p {
                    margin: 0;
                    color: #ffffff;
                }
                .center-up-title {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    flex-grow: 1;
                    box-sizing: border-box;
                    padding: 36px 50px 10px;
                    img {
                        width: 75px;
                        height: 16px;
                        margin-top: 7px;
                    }
                    p {
                        margin: 0;
                        font-size: 24px;
                        color: #ffffff;
                        line-height: 30px;
                        min-height: 60px;
                        text-align: center;
                    }
                }
                .center-up-info {
                    margin: 0 40px 0 140px;
                    > p {
                        font-size: 22px;
                    }
                    ul {
                        padding: 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        height: 274px;
                        li {
                            p {
                                font-size: 16px;
                                color: #ffffff;
                                &.base-label {
                                    color: #edd271;
                                    margin-right: 4px;
                                }
                            }
                        }
                    }
                }
            }
            .center-down {
                height: 466px;
                width: calc(100% - 44px);
                padding: 0 22px;
                ul {
                    height: 466px;
                    width: 100%;
                    padding: 0;
                    li {
                        display: inline-block;
                        width: 49%;
                        height: 220px;
                        background: #000;
                        margin-bottom: 12px;
                        &:nth-child(2n-1) {
                            margin-right: 2%;
                        }
                        .center-down-img {
                            width: 100%;
                            height: 100%;
                            position: relative;
                            img,
                            video {
                                width: 100%;
                                height: 100%;
                                cursor: pointer;
                            }
                            &-vr {
                                width: 50px;
                                height: 50px;
                                line-height: 50px;
                                text-align: center;
                                background-color: rgba(255, 255, 255, 0.8);
                                border-radius: 50%;
                                position: absolute;
                                left: calc(50% - 25px);
                                top: calc(50% - 25px);
                                cursor: pointer;
                                color: #333;
                                font-weight: 600;
                            }
                            &.center-down-video {
                                img {
                                    width: 50px;
                                    height: 50px;
                                    opacity: 0.8;
                                    position: absolute;
                                    left: calc(50% - 25px);
                                    top: calc(50% - 25px);
                                }
                            }
                        }
                    }
                }
            }
        }
        .right {
            width: 618px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .right-up {
                position: relative;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-image: url('../../assets/images/detail/border_2.png');
                width: 100%;
                height: 360px;
                .right-up-time {
                    position: absolute;
                    width: 100%;
                    font-size: 16px;
                    color: #67f0ff;
                    left: 0;
                    bottom: 3px;
                    span {
                        font-size: 16px;
                        color: #edd271;
                    }
                }
                .right-up-price {
                    position: absolute;
                    font-weight: bold;
                    top: calc(50% - 50px);
                    text-align: center;
                    font-size: 36px;
                    line-height: 36px;
                    color: #67f0ff;
                    font-style: italic;
                    font-family: YouSheBiaoTiHei;
                    width: 100%;
                    &._right-up-price {
                        top: calc(50% - 10px);
                    }
                    &._right-up-price_ {
                        top: calc(50% - 70px);
                    }
                    span.price-label {
                        color: #67f0ff;
                        width: 200px;
                        text-align: right;
                    }
                    span.price-number {
                        font-size: 46px;
                        color: #edd271;
                    }
                }
            }
            .right-down {
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-image: url('../../assets/images/detail/border_3.png');
                width: 100%;
                height: 570px;
                position: relative;
                .right-down-list {
                    width: 100%;
                    > p {
                        font-size: 14px;
                        color: #67f0ff;
                        margin-left: 25px;
                        margin-top: 20px;
                        span {
                            margin-left: 40px;
                        }
                    }
                    > p.no-data {
                        position: absolute;
                        top: calc(50% - 10px);
                        text-align: center;
                        font-size: 40px;
                        line-height: 40px;
                        font-style: italic;
                        color: #67f0ff;
                        font-weight: bold;
                        font-family: YouSheBiaoTiHei;
                        width: 100%;
                        margin: 0;
                    }
                    .table-info {
                        padding: 0 10px;
                        width: calc(100% - 20px) !important;
                    }
                }
            }
        }
        > .left,
        > .right,
        > .center {
            background-size: 100% 100%;
            background-repeat: no-repeat;
            box-sizing: border-box;

            position: relative;
            .item-title {
                font-size: 18px;
                color: #40b9f6;
                margin: 20px 0 0 25px;
                &._item-title {
                    margin-top: 57px;
                }
            }
        }
    }
}
</style>
